import { Card, Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EducationPageChrome from './components/EducationPageChrome';

export default function QuestionBankHubPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();
  return (
    <EducationPageChrome title={t('questionBank')} description={t('questionBankIntro')}>
      <Typography.Paragraph type="secondary">{t('questionBankGuardrail')}</Typography.Paragraph>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Card hoverable title={t('questionItems')} onClick={() => navigate('/education/questions/items')}>
            {t('questionItemsIntro')}
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card hoverable title={t('questionBlueprints')} onClick={() => navigate('/education/question-blueprints')}>
            {t('questionBlueprintsIntro')}
          </Card>
        </Col>
      </Row>
    </EducationPageChrome>
  );
}
